import { Event } from '../../../domain/VenueEvent'
import { ElementChoice } from '../../shared/components/element-choice-select/element-choice'

export class BookingEventChoice implements ElementChoice<Event | null> {

    constructor(
        private event: Event | null
    ) { }

    get id(): string {
        if (!this.event) {
            return ''
        }
        return this.event.id
    }

    get displayName(): string {
        if (!this.event) {
            return 'None'
        }
        return this.event.displayName
    }

    get value(): Event | null {
        return this.event
    }
}
